"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTheme;
var _material = require("@ori-ui/mui-bundle/material");
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _theme = _interopRequireDefault(require("../theme"));
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready to use theme object.
 */
function createTheme(options = {}, ...args) {
  const newTheme = (0, _lodash.default)(_theme.default, options);
  return (0, _material.createTheme)(newTheme, ...args);
}
